import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {last} from 'lodash';
import PIPELINE_STEPS from '../../utils/pipeline_steps';
import {createPipelineStep, currentPipeline} from '../../utils/pipeline_utils';
import PipelineBranch from './pipeline_branch';
import PipelineModel from '../../models/pipeline';

export default class Pipeline extends Component {
    addQuery() {
        // NOT WORKING, but the start of multiple datasets
        // const lastStep = last(last(this.props.pipeline.getBranches()));
        // const data = {datasource: 'chinook'};
        // const newStep = createPipelineStep(PIPELINE_STEPS.DATASET, data, currentPipeline);
        // this.props.addOrUpdateStep(newStep);
        // const mergeStep = createPipelineStep(PIPELINE_STEPS.MERGE, {parents: [lastStep.id, newStep.id]});
        // this.props.addOrUpdateStep(mergeStep);
    }

    render() {
        const {pipeline, addOrUpdateStep, removeStep} = this.props;
        return (
            <div className="vertical-flex">
                {pipeline.getBranches().map(branch => (
                    <PipelineBranch
                        key={branch[0].id}
                        branch={branch}
                        addOrUpdateStep={addOrUpdateStep}
                        removeStep={removeStep}
                    />
                ))}
                {/*<div className="add-query-container" onClick={this.addQuery.bind(this)}>*/}
                    {/*<img className="add-query-icon" src="/images/plus.svg" alt="Add Query"/>*/}
                    {/*<div className="add-query-text">Add Query</div>*/}
                {/*</div>*/}
            </div>
        );
    }
}

Pipeline.propTypes = {
    pipeline: PropTypes.instanceOf(PipelineModel).isRequired,
    addOrUpdateStep: PropTypes.func.isRequired,
    removeStep: PropTypes.func.isRequired,
};
